export const environment = {
  production: true,
  development: false,
  test: false,
  brand: 'Vyv',
  apiRootUrl: 'https://vyvfrprodmrhapi001.azurewebsites.net',
  frontUrl: '__FrontUrl__',
  appInsightsKey: '9570e8f3-154f-4bae-96aa-d51be51f15fb',
  assConfort:
    'https://vyvfrprodmrhst001.blob.core.windows.net/public/documents/220830_VYV_TG_ASS_HAB_CONFORT.pdf',
  assParisienne:
    'https://vyvfrprodmrhst001.blob.core.windows.net/public/documents/230830_VYV_TG_ASS_HAB_PARISIENNE.pdf',
  assSolidaire:
    'https://vyvfrprodmrhst001.blob.core.windows.net/public/documents/230830_VYV_TG_ASS_HAB_SOLIDAIRE.pdf',
  wcbMRH_S: 'https://wcb-vyv-mrh.assurone.com/VYVCONSEILMRHSOLIDAIRE',
  wcbMRH_C: 'https://wcb-vyv-mrh.assurone.com/VYVCONSEILMRH',
  matomoSiteId: '15',
  matomoHostUrl: 'https://stats.groupe-vyv.fr/',
  matomoScriptUrl: 'https://stats.groupe-vyv.fr/js/container_dEtShPrA.js',
  modeleCourrierResiliation:
    'https://vyvfrprodmrhst001.blob.core.windows.net/public/documents/ModeleCourrier.docx'
};
